<div role="contentinfo" class="footer d-flex flex-column align-items-center justify-content-center gap-footer text-white text-center">
  <img class="footer-logo" [src]="'logos/phxid-logo.svg' | contentAssetImage" alt="PHX ID" draggable="false" />
  <div class="footer-text">
    <p class="mb-0">{{ 'nav.club.rights' | translate }}</p>
    <p class="mb-0">{{ 'nav.footer.web.solution' | translate }}</p>
  </div>
</div>
